module.exports = __webpack_public_path__ + "img/mockup-all-fund.f6ce8010.png";